import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SplashScreen from './components/SplashScreen';
import BrandPanel from './components/BrandPanel';
import LoginForm from './components/LoginForm';
import RegistrationForm from './components/RegistrationForm';
import WelcomeWizard from './components/WelcomeWizard';

// VIEW STATES: splash | login | register | wizard
export default function OnboardingAuthentication() {
  const navigate = useNavigate();
  const [view, setView] = useState('splash');
  const [registeredUser, setRegisteredUser] = useState(null);

  const handleSplashComplete = () => setView('login');

  const handleRegistrationSuccess = (userData) => {
    setRegisteredUser(userData);
    setView('wizard');
  };

  const handleWizardComplete = () => {
    navigate('/home-dashboard');
  };

  const handleLoginSuccess = () => {
    navigate('/home-dashboard');
  };

  if (view === 'splash') {
    return <SplashScreen onComplete={handleSplashComplete} />;
  }

  return (
    <div className="min-h-screen flex" style={{ background: 'var(--color-background)' }}>
      {/* Left Brand Panel - Desktop Only */}
      <div className="lg:w-5/12 xl:w-2/5 flex-shrink-0">
        <BrandPanel />
      </div>
      {/* Right Content Panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 md:px-8 lg:px-12 py-8 overflow-y-auto"
        style={{ minHeight: '100vh' }}>
        {/* Mobile Logo */}
        <div className="lg:hidden flex items-center gap-2 mb-8">
          <div className="rounded-xl flex items-center justify-center"
            style={{ width: 40, height: 40, background: 'var(--color-primary)' }}>
            <span style={{ fontSize: 20, color: 'var(--color-accent)' }}>♀</span>
          </div>
          <div>
            <div style={{ fontFamily: 'var(--font-heading)', fontSize: '1.25rem', fontWeight: 700, color: 'var(--color-primary)', letterSpacing: '0.15em' }}>WIN</div>
            <div style={{ fontFamily: 'var(--font-caption)', fontSize: '0.625rem', color: 'var(--color-muted-foreground)', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Women Invest Network</div>
          </div>
        </div>

        <div className="w-full max-w-md">
          {view === 'login' && (
            <LoginForm
              onSwitchToRegister={() => setView('register')}
              onLoginSuccess={handleLoginSuccess}
            />
          )}
          {view === 'register' && (
            <RegistrationForm
              onSuccess={handleRegistrationSuccess}
              onSwitchToLogin={() => setView('login')}
            />
          )}
          {view === 'wizard' && (
            <WelcomeWizard
              userData={registeredUser}
              onComplete={handleWizardComplete}
            />
          )}
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <p style={{ fontFamily: 'var(--font-caption)', fontSize: '0.75rem', color: 'var(--color-muted-foreground)' }}>
            &copy; {new Date()?.getFullYear()} Women Invest Network. All rights reserved.
          </p>
          <div className="flex items-center justify-center gap-4 mt-2">
            {['Privacy Policy', 'Terms of Service', 'Support']?.map(link => (
              <button key={link} style={{ fontFamily: 'var(--font-caption)', fontSize: '0.75rem', color: 'var(--color-muted-foreground)', background: 'none', border: 'none', cursor: 'pointer' }}
                onMouseEnter={e => e.currentTarget.style.color = 'var(--color-accent)'}
                onMouseLeave={e => e.currentTarget.style.color = 'var(--color-muted-foreground)'}>
                {link}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}